// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"23903405","331":"e4dfd8fa","486":"7ca8f51a","517":"2c3e729c","732":"d23073af"}[chunkId] + ".chunk.js";
};